import { useState, useEffect, useCallback } from 'react';
import {
  getFactureById,
  getAllFactures,
  validateFacture,validateFactureTree,
  getAllDetailFacturesByFacture,
  cancelFacture,  saveFacture, unvalidateFacture, deleteFacture,
  getFacturesByClient,
  // Seed DBF upload
  uploadFacturesDBF,
  uploadFacturesDetailsDBF,
  uploadBothFacturesDBF
} from '../models/factureAPI'; // Adjust the import path as necessary



export const useFetchFactureById = (id) => {
  const [facture, setFacture] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Define the fetching logic as a callable function using useCallback
  const fetchFacture = useCallback(() => {
    if (id) {
      setLoading(true);
      setError(''); // Reset error state before new fetch attempt
      getFactureById(id)
        .then(response => {
          setFacture(response.data);
          setLoading(false);
        })
        .catch(err => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [id]);

  // Invoke fetchFacture when the component mounts and when id changes
  useEffect(() => {
    fetchFacture();
  }, [fetchFacture]);

  // Return all the state management vars and the refetch function
  return { facture, loading, error, refetch: fetchFacture };
};

export const useFetchAllFactures = (params) => {
  const [factures, setFactures] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchFactures = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const { data } = await getAllFactures(params);
      setFactures(data.factures);
      setTotal(data.total);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching factures:', err);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchFactures();
  }, [fetchFactures]);

  return { factures, total, loading, error, refetch: fetchFactures };
};






export const useValidateFacture = () => {
  const [error, setError] = useState('');
  const [isValidated, setIsValidated] = useState(false);

  const validate = async (refFAC) => {
    setError('');
    try {
      await validateFacture(refFAC);
      setIsValidated(true);
    } catch (err) {
      const reason = err.response?.data?.message || err.message;
      setError(reason);
      setIsValidated(false);
      throw new Error(reason);
    }
  };

  return { validate, error, isValidated };
};


export const useValidateFactureTree = () => {
  const [error, setError] = useState('');
  const [isValidatedtree, setIsValidatedtree] = useState(false);

  const validatetree = async (refFAC) => {
    setError('');
    try {
      await validateFactureTree(refFAC);
      setIsValidatedtree(true);
    } catch (err) {
      const reason = err.response?.data?.message || err.message;
      setError(reason);
      setIsValidatedtree(false);
      throw new Error(reason);
    }
  };

  return { validatetree, error, isValidatedtree };
};

export const useFetchDetailFacturesByFacture = (refFAC) => {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchDetails = useCallback(() => {
    if (refFAC) {
      setLoading(true);
      getAllDetailFacturesByFacture(refFAC)
        .then(response => {
          setDetails(response.data);
          setLoading(false);
        })
        .catch(err => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [refFAC]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  const refetch = useCallback(() => {
    fetchDetails();
  }, [fetchDetails]);

  return { details, loading, error, refetch };
};
export const useCancelFacture = () => {
  const [error, setError] = useState('');
  const [isCancelled, setIsCancelled] = useState(false);

  const handleCancel = async (refFAC) => {
      try {
          await cancelFacture(refFAC);
          setIsCancelled(true);
      } catch (err) {
          setError(err.message);
          setIsCancelled(false);
      }
  };

  return { handleCancel, error, isCancelled };
};


export const useSaveFacture = () => {
  const [error, setError] = useState('');
  const [isSaved, setIsSaved] = useState(false);

  const handleSaveFacture = async (refFAC, factureData, detailsData) => {
    try {
      await saveFacture(refFAC, factureData, detailsData);
      setIsSaved(true);
      setError('');
    } catch (err) {
      console.error('Error in useSaveFacture:', err);
      setError(err.message);
      setIsSaved(false);
      throw err; // Re-throw the error so it can be caught in the component
    }
  };

  return { handleSaveFacture, error, isSaved };
};

// hooks/factureHooks.js
export const useUnvalidateFacture = () => {
  const [error, setError] = useState('');
  const [isUnvalidated, setIsUnvalidated] = useState(false);

  const unvalidate = async (refFAC) => {
    try {
      const result = await unvalidateFacture(refFAC);
      setIsUnvalidated(true);
      setError('');
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message;
      setError(errorMessage);
      setIsUnvalidated(false);
      throw err;
    }
  };

  return { unvalidate, error, isUnvalidated };
};




export const useDeleteFacture = () => {
  const [error, setError] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async (refFAC) => {
    setLoading(true);
    try {
      await deleteFacture(refFAC);
      setIsDeleted(true);
      setError('');
    } catch (err) {
      setError(err.message);
      setIsDeleted(false);
    } finally {
      setLoading(false);
    }
  };

  return { handleDelete, error, isDeleted, loading };
};

export const useFetchFacturesByClient = (compte) => {
  const [factures, setFactures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchFactures = useCallback(() => {
    if (compte) {
      setLoading(true);
      setError('');
      getFacturesByClient(compte)
        .then(response => {
          setFactures(response.data);
          setLoading(false);
        })
        .catch(err => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [compte]);

  useEffect(() => {
    fetchFactures();
  }, [fetchFactures]);

  return { factures, loading, error, refetch: fetchFactures };
};

// Seed DBF upload hooks
export const useUploadFacturesDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (file) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await uploadFacturesDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

export const useUploadFacturesDetailsDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (file) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await uploadFacturesDetailsDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};

export const useUploadBothFacturesDBF = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (facturesFile, detailsFile) => {
    setLoading(true);
    setError('');
    setUploadResult(null);

    const formData = new FormData();
    formData.append('facturesFile', facturesFile);
    formData.append('detailsFile', detailsFile);

    try {
      const response = await uploadBothFacturesDBF(formData);
      setUploadResult(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during upload';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { handleUpload, loading, error, uploadResult };
};
